// select the url
//select the two spans with the class trp-ls-language-name

// if the url has the slug fr then choose the span with the class class trp-ls-language-name and compair the two inside html words en and fr.

// if the url has an fr then apply the deactivae class to the span that has en in its inner html
let langButton = document.getElementsByClassName('trp-ls-language-name');
// console.log(langButton[0].textContent); // EN
// console.log(langButton[1].textContent); // FR
export function translateActivated() {

}